export default "__VITE_ASSET__HFnSo_t2ji54Ii8fKeJyow__";